/**
 * Centralized query key factory for TanStack Query.
 * This ensures consistent cache keys across the app and enables targeted invalidation.
 */
export const queryKeys = {
  credits: ['credits'] as const,

  designs: {
    all: ['designs'] as const,
    list: (params: Record<string, unknown>) => ['designs', 'list', params] as const,
    detail: (id: string) => ['designs', 'detail', id] as const,
  },

  batches: {
    all: ['batches'] as const,
    list: (params: Record<string, unknown>) => ['batches', 'list', params] as const,
    detail: (id: string) => ['batches', 'detail', id] as const,
  },

  tasks: {
    all: ['tasks'] as const,
    list: (params: Record<string, unknown>) => ['tasks', 'list', params] as const,
  },
}
